import React, { createContext, useContext, useState, useEffect } from 'react';
import { axiosInstance } from '../api';

const CompanyModulesContext = createContext({ modules: null, loading: true });

export function CompanyModulesProvider({ children }) {
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get('api/company-modules/')
      .then((res) => setModules(new Set(res.data.modules)))
      .catch(() => setModules(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <CompanyModulesContext.Provider value={{ modules, loading }}>
      {children}
    </CompanyModulesContext.Provider>
  );
}

export function useCompanyModules() {
  return useContext(CompanyModulesContext);
}

export function isModuleEnabled(modules, moduleId) {
  if (!modules) return true;
  return modules.has(moduleId);
}
